<script setup lang="ts">
import {useAdminGnbStore} from "~/store/layout/admingnb";
import {adminmenuiconPath} from "~/utils/imgpath";
import {useAuthStore} from "~/store/admin/login/auth";
import {useRoute} from '#imports';
import {computed} from "vue";

const auth = useAuthStore();
const gnbStore = useAdminGnbStore();
const menus = computed(() => gnbStore.depth);

/* 활성 메뉴 하이라이트 (선택) */
const route = useRoute();
const selectedKeys = computed(() => [route.path]);

// 헬퍼: 준비중 여부
const isPending = (node: any) => !!node?.pending
</script>
<template>
  <a-layout-sider class="admin-sider" width="330">
    <div class="sider-box">
      <div class="sider-logo-box">
        <span class="icon-span">
          <img src="~/assets/img/pc/main/logo.svg" alt="로고" />
        </span>
        <strong>{{ auth.userName }}</strong>
      </div>

      <a-menu mode="inline" :selectedKeys="selectedKeys">
        <!-- 1-depth -->
        <template v-for="item in menus" :key="item.id">
          <!-- 하위가 있을 때 -->
          <a-sub-menu v-if="item.children" :key="`submenu-${item.id}`" :popupClassName="'gnb-sub'">
            <template #title>
              <img v-if="item.icon" :src="adminmenuiconPath(item.icon)" />
              <!-- ✅ 준비중이면 타이틀 자체에 알림 클래스 부여 -->
              <span
                  class="title-span"
                  :class="{ 'common-basic-alert': isPending(item) }"
              >
              {{ item.label }}
              </span>
            </template>

            <!-- 2-depth -->
            <template v-for="child in item.children" :key="child.id">
              <a-menu-item
                  v-if="!child.minLevel || (auth.mbLevel ?? 0) >= child.minLevel"
                  :class="{ 'ant-menu-item-selected': child.url === route.path }"
              >
                <!-- ✅ 하위도 준비중이면 라우팅 막고 알림만 -->
                <template v-if="isPending(child)">
                  <a href="#" class="common-basic-alert">{{ child.label }}</a>
                </template>
                <template v-else>
                  <NuxtLink :to="child.url">{{ child.label }}</NuxtLink>
                </template>
              </a-menu-item>
            </template>
          </a-sub-menu>

          <!-- 하위가 없을 때 -->
          <a-menu-item
              v-else
              :key="`menu-${item.id}`"
              :class="{ 'ant-menu-item-selected': item.url === route.path }"
          >
            <img v-if="item.icon" :src="adminmenuiconPath(item.icon)" />
            <!-- ✅ 이메일관리(준비중) -->
            <template v-if="isPending(item)">
              <a href="#" class="common-basic-alert">{{ item.label }}</a>
            </template>
            <template v-else>
              <NuxtLink :to="item.url ?? '#'">{{ item.label }}</NuxtLink>
            </template>
          </a-menu-item>
        </template>
      </a-menu>
    </div>
  </a-layout-sider>
</template>

<style scoped lang="scss">

</style>